module.exports = __webpack_public_path__ + "img/airbase-stage_2.2.df22f1b8.jpg";